export default __webpack_public_path__ + "static/Gilroy-Medium-1b4da6582f83f45ea039e1f68037e386.ttf";